import { request } from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'

export const fetchNews = ({
  commit, state
}, { page, pageSize }) => {
  pageSize = state.pageSize
  return request(API.NEWS, 'GET', {
    page,
    pageSize
  })
}

export const updateList = ({
  commit, state
}, { data }) => {
  commit(types.UPDATE_LIST, { data })
}



// WEBPACK FOOTER //
// ./src/store/news/actions.js